module.exports = __webpack_public_path__ + "static/img/22b.9edd937.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22b.jpg
// module id = fa/U
// module chunks = 0